<template>
  <div class="add-to-cart mt-1 w-100">
    <CustomSelect
      v-if="showQuantitySelect && hideElementBecauseLimitingIsActive"
      class="add-to-cart__quantity"
      :class="{ 'add-to-cart__quantity--hide-select' : (maxToCart === 0) }"
      data-cy="add-to-cart-quantity-select"
      :options="quantitySelect"
      @change="updateSelectedAmount" />
    <template v-if="productInfo.isMerchandise && availableMerchandiseCarts.length > 1 && hideElementBecauseLimitingIsActive">
      <CustomSelect
        class="add-to-cart__merchandise"
        data-cy="add-to-cart-merchandise-select"
        :options="merchandiseSelect"
        :selected="selectedCartId"
        @change="updateSelectedCartId" />
    </template>
    <template v-if="!productInfo.isMerchandise && hasMultipleCarts && hideElementBecauseLimitingIsActive">
      <CustomSelect
        class="add-to-cart__cart"
        data-cy="add-to-cart-select"
        :options="cartSelect"
        :selected="selectedCartId"
        @change="updateSelectedCartId" />
    </template>
    <template v-if="maxToCart > 0 && hideElementBecauseLimitingIsActive">
      <template v-if="addToCartButtonDisplayMode === `simple-button`">
        <p
          v-if="!loading"
          class="add-to-cart__button add-to-cart__button--simple"
          @click="addItemToCart">
          {{ t.addToCart }}
        </p>
        <div
          v-if="loading"
          class="cp-round cp-spinner"></div>
      </template>
      <CustomButton
        v-if="addToCartButtonDisplayMode === `full-button`"
        class="add-to-cart__button add-to-cart__button--full"
        data-cy="add-to-cart-button"
        :loading="loading"
        mode="dark"
        :text="t.addToCart"
        @click="addItemToCart" />
    </template>
  </div>
</template>

<script>
  import CustomButton from '../../layout/buttons/CustomButton';
  import CustomSelect from '../../layout/inputs/CustomSelect';
  import OldFormatHelper from '../../../helpers/OldFormatHelper';
  import PriceMethods from '../../../methods/PriceMethods';

  export default {
    components: { CustomButton, CustomSelect },
    data() {
      return {
        cartSelect: [],
        defaultQuantitySelect: [
          { code: 1, label: this.t.onePiece },
          { code: 2, label: this.t.twoPieces },
          { code: 3, label: this.t.threePieces },
          { code: 4, label: this.t.fourPieces },
          { code: 5, label: this.t.fivePieces },
        ],
        formatHelper: OldFormatHelper,
        merchandiseSelect: [],
        quantitySelect: [
          { code: 1, label: this.t.onePiece },
          { code: 2, label: this.t.twoPieces },
          { code: 3, label: this.t.threePieces },
          { code: 4, label: this.t.fourPieces },
          { code: 5, label: this.t.fivePieces },
        ],
      };
    },
    computed: {
      hideElementBecauseLimitingIsActive() {
        return !this.limiting.active || (this.limiting.active && this.limiting.shoppingAllowed);
      },
    },
    props: {
      addToCartButtonDisplayMode: {
        default: `full-button`,
        type: String,
      },
      availableCarts: {
        required: true,
        type: Array,
      },
      availableMerchandiseCarts: {
        required: true,
        type: Array,
      },
      hasMultipleCarts: {
        required: true,
        type: Boolean,
      },
      limiting: {
        required: true,
        type: Object,
      },
      loading: {
        required: true,
        type: Boolean,
      },
      maxToCart: {
        default: 999,
        type: Number,
      },
      productInfo: {
        required: true,
        type: Object,
      },
      selectedCartId: {
        required: true,
        validator: prop => Number.isInteger(prop) || prop === null,
      },
      showQuantitySelect: {
        default: true,
        type: Boolean,
      },
      t: {
        required: true,
        type: Object,
      },
    },
    methods: {
      ...PriceMethods,
      addItemToCart() {
        this.$emit(`add-item-to-cart`, this.productInfo.isMerchandise);
      },
      resetOptions() {
        this.quantitySelect = this.defaultQuantitySelect.filter(option => option.code <= this.maxToCart);
      },
      setUpCartDropdownData() {
        if(this.cartSelect.length === 0) {
          this.availableCarts.forEach(cart => {
            this.cartSelect.push({ code: cart.cartId, label: this.formatHelper.formatFullAddress(cart.invoiceAddress, cart.cartTypeId) });
          });
        }
      },
      setUpMerchandiseDropdownData() {
        if(this.merchandiseSelect.length === 0) {
          this.availableMerchandiseCarts.forEach(cart => {
            this.merchandiseSelect.push({ code: cart.cartId, label: this.formatHelper.formatFullAddress(cart.invoiceAddress, cart.cartTypeId) });
          });
        }
      },
      updateSelectedAmount(event) {
        this.$emit(`update:selected-product-amount`, event);
      },
      updateSelectedCartId(event) {
        this.$emit(`update:selected-cart-id`, event);
      },
    },
    watch: {
      availableCarts: {
        handler() { this.setUpCartDropdownData(); },
        immediate: true,
      },
      availableMerchandiseCarts: {
        handler() { this.setUpMerchandiseDropdownData(); },
        immediate: true,
      },
      maxToCart: {
        handler() { this.resetOptions(); },
        immediate: true,
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/styles/rin-variables';

  .add-to-cart {
    &__button--full {
      width: 100%;
    }

    &__button--simple {
      border-bottom: 1px solid @colorBlack;
      cursor: pointer;
      display: inline-block;
      font-size: @fontSizeXS - 1;
      letter-spacing: 2.5px;
      margin-bottom: 5px;
      text-transform: uppercase;
    }

    &--dropdown-top .vs__dropdown-menu {
      bottom: ~'calc(100% - 1px)';
      max-height: 350px;
      max-width: 600px;
      top: auto;
    }

    &__quantity--hide-select {
      display: none;
    }
  }
</style>
